import { useContext } from "react";
import { Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow } from "@mui/material";
import { userGroupsContext } from '../UserGroupsContext';
import { DeleteIconButton } from "components";
import UserGroupEditor from './UserGroupEditor';
import Moment from "react-moment";

let Results = () => {
    let service = useContext(userGroupsContext);

    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Codice</TableCell>
                        <TableCell>Descrizione</TableCell>
                        <TableCell>Aggiornato</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.userGroups.map((group, index) =>
                        <TableRow hover key={index}>
                            <TableCell>{group.key}</TableCell>
                            <TableCell>{group.description}</TableCell>
                            <TableCell>{group.lastUpdatedBy}&nbsp;il&nbsp;<Moment date={group.lastUpdatedOn} format="LLL" /></TableCell>
                            <TableCell align="right">
                                <UserGroupEditor id={group.id} />
                                <DeleteIconButton onClick={async () => await service.deleteUserGroup(group.id)} />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {service.userGroups.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={4}><i>Nessun gruppo è stato trovato</i></TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
            <TablePagination
                component="div"
                count={service.recordCount}
                onPageChange={(e, pageNr) => service.handleChangePage(pageNr)}
                page={service.search.pageNr}
                rowsPerPage={service.search.pageSize}
                rowsPerPageOptions={[service.search.pageSize]}
                labelDisplayedRows={({ page, count }) =>
                    <>
                        Gruppi trovati:&nbsp;{count} &nbsp;&middot;&nbsp;
                        <span>Pagina {page + 1} di {Math.ceil(count / service.search.pageSize)}</span>
                    </>
                }
            />
        </>
    )
}

export default Results;